import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { MD5 } from "crypto-js";
import { CircularProgress, Dialog, IconButton, TextField } from "@mui/material";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import "./RevokeAccessDialog.css";
import "../Components/Components.css";
import { unlockAgent } from "../Store/Actions/AuthAction";

const RevokeAccessDialog = ({ isOpen, setIsRevokeAccessDialogShown }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [validName, setValidName] = useState(false);
  const [validPwd, setValidPwd] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const USER_REGEX = /^[a-zA-Z][a-zA-Z0-9-_]{4,23}$/;
    const result = USER_REGEX.test(username);
    setValidName(result);
  }, [username]);

  useEffect(() => {
    const PWD_REGEX = /^[A-Za-z0-9_.!]{4,24}$/;
    const result = PWD_REGEX.test(password);
    setValidPwd(result);
  }, [password]);

  const handleClose = () => {
    setIsRevokeAccessDialogShown(false);
    setUsername("");
    setPassword("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    unlockAgent({
      username: username,
      password: MD5(password).toString(),
    })
      .then((response) => {
        if (response.status) {
          console.log("unlockAgent: ", response.data);
          toast.success("Access has been revoked", { autoClose: 3000 });
          setIsSubmitting(false);
          handleClose();
        } else {
          console.log("error", response.error);

          if (
            response.error.includes("User Not Found!") ||
            response.error.includes("Invalid Password!")
          ) {
            setErrorMessage(
              "Username or Password is invalid. Please check again."
            );
          } else {
            toast.error("Error revoking access", { autoClose: 3000 });
          }

          setIsSubmitting(false);
        }
      })
      .catch((err) => {
        console.log("err", err);
        toast.error("Error revoking access", { autoClose: 3000 });
        setIsSubmitting(false);
      });
  };

  return (
    <Dialog
      open={isOpen}
      className="dialog revoke-access-dialog"
      fullWidth
      maxWidth="md"
      scroll="paper"
      onClose={handleClose}
    >
      <div className="dialog-container">
        <form method="post" onSubmit={handleSubmit}>
          <div className="dialog-content">
            <h2 className="title">Revoke Access</h2>

            <IconButton className="close-button" onClick={handleClose}>
              <CloseOutlined />
            </IconButton>

            <div className="text-fields">
              <p className={`error-message ${errorMessage ? "visible" : ""}`}>
                {errorMessage}
              </p>

              <TextField
                autoComplete="off"
                error={errorMessage ? true : username ? !validName : false}
                id="username"
                label="Username"
                name="username"
                required
                value={username}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setErrorMessage("");
                }}
              />

              <TextField
                autoComplete="off"
                error={errorMessage ? true : password ? !validPwd : false}
                id="password"
                label="Password"
                name="password"
                required
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setErrorMessage("");
                }}
              />
            </div>
          </div>

          <section className="buttons">
            <button className="cancel" type="button" onClick={handleClose}>
              Cancel
            </button>

            <button className="confirm" disabled={isSubmitting} type="submit">
              {isSubmitting && <CircularProgress className="progress" />}
              Confirm
            </button>
          </section>
        </form>
      </div>
    </Dialog>
  );
};

export default RevokeAccessDialog;
